import { useSetRecoilState } from 'recoil'

import { snackbarStore, SnackbarStoreType } from './snackbarStore'

export type TypeUserSnackbarAction = ReturnType<typeof useSnackbarAction>

const useSnackbarAction = () => {
    const setSnackbarStore = useSetRecoilState(snackbarStore)

    const openSnackbar = (props?: Pick<SnackbarStoreType, 'message' | 'type'>) => {
        setSnackbarStore((prevState) => ({
            ...prevState,
            isOpen: true,
            message: props?.message || '',
            type: props?.type || 'success',
        }))
    }
    const closeSnackbar = () => {
        setSnackbarStore((prevState) => ({
            ...prevState,
            isOpen: false,
        }))
    }

    return {
        openSnackbar,
        closeSnackbar,
    }
}

export default useSnackbarAction
